import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import type { GeomateNotification, NotificationId } from 'common/types'

export const notificationsAdapter = createEntityAdapter<GeomateNotification>({
  selectId: notification => notification.id,
})

const initialState = notificationsAdapter.getInitialState()

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification(state, { payload }: PayloadAction<GeomateNotification>) {
      notificationsAdapter.upsertOne(state, payload)
    },
    removeNotification(state, { payload }: PayloadAction<NotificationId>) {
      notificationsAdapter.removeOne(state, payload)
    },
  },
})

export default notificationsSlice.reducer
